export default {
  title: 'Log de Erros',
  cleanupOld: 'Limpar Antigos',
  refresh: 'Atualizar',
  selected: '{count} selecionados',
  markResolved: 'Marcar como Resolvido',
  markOpen: 'Marcar como Aberto',
  clear: 'Limpar',
  filters: {
    startDate: 'Data de Início',
    endDate: 'Data de Fim',
    errorType: 'Tipo de Erro',
    status: 'Status',
    searchPlaceholder: 'Buscar mensagem ou usuário'
  },
  headers: {
    type: 'Tipo',
    message: 'Mensagem',
    user: 'Usuário',
    timestamp: 'Data e Hora',
    status: 'Status'
  },
  errorTypes: {
    javascript: 'JavaScript',
    vue: 'Vue',
    promise: 'Promise',
    manual: 'Manual',
    warning: 'Aviso',
    info: 'Informação'
  },
  statusOptions: {
    open: 'Aberto',
    resolved: 'Resolvido'
  },
  anonymous: 'Anônimo',
  unknown: 'Desconhecido',
  noData: 'Nenhum registro de erro encontrado',
  details: {
    title: 'Detalhes do Erro',
    message: 'Mensagem',
    errorName: 'Nome do Erro',
    url: 'URL',
    route: 'Rota',
    userAgent: 'User Agent',
    resolvedAt: 'Resolvido em',
    context: 'Contexto',
    stackTrace: 'Stack Trace'
  },
  cleanup: {
    title: 'Limpar Erros Antigos',
    description: 'Isso excluirá permanentemente os registros de erros com mais de {days} dias.',
    daysToKeep: 'Dias a manter',
    cancel: 'Cancelar',
    delete: 'Excluir'
  },
  snackbar: {
    loadFailed: 'Erro ao carregar o log de erros',
    markedAsResolved: 'Erro marcado como resolvido',
    markedAsOpen: 'Erro marcado como aberto',
    updateFailed: 'Erro ao atualizar o status do erro',
    noErrorsSelected: 'Nenhum erro selecionado',
    bulkUpdateSuccess: '{count} erros marcados como {status}',
    bulkUpdateFailed: 'Erro ao atualizar erros em lote',
    cleanupSuccess: '{count} registros de erros antigos foram excluídos',
    cleanupFailed: 'Erro ao limpar registros antigos'
  },
  notAvailable: 'N/D'
}
